module.exports = __webpack_public_path__ + "static/media/Image-Values2.a1455adf.png";